export default __webpack_public_path__ + "static/media/cx.d1447c43.svg";